import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaSignInAlt } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";

const TypingEffect = () => {
  const [currentText, setCurrentText] = useState('');
  const fullText = "Välkommen. Logga in för att fortsätta.";
  const typingSpeed = 100;

  useEffect(() => {
    if (currentText.length < fullText.length) {
      const timer = setTimeout(() => {
        setCurrentText(fullText.substring(0, currentText.length + 1));
      }, typingSpeed);

      return () => clearTimeout(timer);
    }
  }, [currentText, fullText]);

  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">{currentText}</h1>
    </div>
  );
};

const Login = () => {
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const loginResult = await login(password);
      
      if (loginResult.success) {
        // Navigate based on user role
        if (loginResult.isAdmin) {
          navigate('/admin');
        } else {
          navigate('/'); 
        }
      } else {
        setError('Fel lösenord, försök igen.');
      }
    } catch (error) {
      setError('Inloggning misslyckades, försök igen.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-50 flex justify-center items-center p-6">
      <div className="card max-w-md w-full animate-scale-in">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <FaLock className="text-2xl text-primary-600" />
          </div>
          <TypingEffect />
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="label flex items-center">
              <FaLock className="mr-2 text-primary-600" />
              Lösenord
            </label>
            <InputField
              type="password"
              placeholder="Ange ditt lösenord"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              icon={<FaLock />}
            />
          </div>
          
          {error && (
            <div className="bg-red-50 border-l-4 border-red-500 rounded-lg p-4 animate-fade-in">
              <p className="text-sm text-red-700">{error}</p>
            </div>
          )}
          
          <button
            type="submit"
            disabled={isLoading || !password.trim()}
            className="btn-primary w-full"
          >
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 flex-shrink-0"></div>
                <span>Loggar in...</span>
              </>
            ) : (
              <>
                <FaSignInAlt className="mr-2 flex-shrink-0" />
                <span>Logga In</span>
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

const InputField = ({ type, placeholder, value, onChange, icon }) => (
  <div className="relative">
    <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">{icon}</span>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="input-field pl-12"
      autoComplete={type === "password" ? "current-password" : "off"}
    />
  </div>
);

export default Login;
